export default {
  props: {
    sourceType: {
      type: String,
      default: ''
    },
    hasPrivate: {
      type: Boolean,
      default: false
    },
    hasHearAudio: {
      type: Boolean,
      default: false
    },
    hasSeeVideo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    privateComputed() {
      // 如果源类型是 sdi 则不会有打开状态
      if (this.sourceType === 'sdi') {
        return 'icon-a-intercomoff2 disable';
      } else {
        return this.hasPrivate ? 'icon-a-intercomon gray pointer' : 'icon-a-intercomoff2 red pointer';
      }
    },
    speakerComputed() {
      return this.hasHearAudio ? 'icon-a-speakeron gray pointer' : 'icon-a-speakeroff red pointer';
    },
    cameraComputed() {
      return this.hasSeeVideo ? 'icon-a-cameraon gray pointer' : 'icon-a-cameraoffTVU_agora_video_close red pointer';
    }
  },
  data() {
    return {
      hearVoice: false,
      seeVideo: false
    };
  }
};